import IndustryPageTemplate from "./IndustryPageTemplate";
import { therapistsData } from "@/data/therapists";

export default function TherapistsPage() {
  return <IndustryPageTemplate data={therapistsData} />;
}
